import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { get } from "../../../utils/request";
import { getQueryValue } from "../../../utils/tool";
import { actions as intelligentbigdataActions } from "../../../redux/modules/intelligentbigdata";
import "./style.css";
class IntelligentBigDataKeySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      placeholder: "",
      clickName: "取消",
      name: "",
      keys: [],
      tip: "",
    };
  }
  componentDidMount() {
    this.textInput.focus();
    if (getQueryValue("type") === "school") {
      this.setState({
        name: this.props.schoolFilter.schoolName,
        clickName: this.props.schoolFilter.schoolName !== "" ? "搜索" : "取消",
        type: "school",
        placeholder: "请输入学校名称",
        tip: "搜大学：",
      });
    } else if (getQueryValue("type") === "major") {
      this.setState({
        name: this.props.schoolFilter.majorName,
        clickName: this.props.schoolFilter.majorName !== "" ? "搜索" : "取消",
        type: "major",
        placeholder: "请输入专业名称",
        tip: "搜专业：",
      });
    }
  }
  render() {
    const { keys, placeholder, tip } = this.state;
    return (
      <div className="intelligentQueryKeySearch_box">
        <div className="intelligentQueryKeySearch_box_div">
          <div className="intelligentQueryKeySearch_box_left fl">
            <div className="intelligentQueryKeySearch_box_left_div">
              <div className="intelligentQueryKeySearch_box_left_div_img fl">
                <img
                  alt=""
                  src={require("../../../images/search/search_2.png")}
                ></img>
              </div>
              <div className="intelligentQueryKeySearch_box_left_div_input fl">
                <span
                  style={{
                    fontSize: 14,
                    color: "#666",
                    position: "relative",
                    top: 2,
                  }}
                >
                  {tip}
                </span>
                <input
                  value={this.state.name}
                  onChange={this.handleChang}
                  ref={(input) => {
                    this.textInput = input;
                  }}
                  placeholder={placeholder}
                ></input>
              </div>
              <div
                style={{
                  display: this.state.name !== "" ? "block" : "none",
                }}
                className="intelligentQueryKeySearch_box_right_div_img fr"
                onClick={() => this.handleRemoveName()}
              >
                <img
                  alt=""
                  src={require("../../../images/search/search_3.png")}
                ></img>
              </div>
            </div>
          </div>
          <div className="intelligentQueryKeySearch_box_right fl">
            <div
              onClick={this.handleSearch}
              className="intelligentQueryKeySearch_box_right_txt fl"
            >
              {this.state.clickName}
            </div>
          </div>
          <div className="clear"></div>
        </div>
        <div style={{ height: 44 }}></div>
        <div className="intelligentQueryKeySearch_box_item">
          {keys.map((item, index) => {
            return (
              <div
                key={index}
                onClick={this.handleClick.bind(this, item)}
                className="intelligentQueryKeySearch_item"
              >
                {item}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  /**
   * 点击选项跳转到智能大数据页面
   */
  handleClick = (item) => {
    this.storageData(item);
    this.resetPageNum();
    this.props.history.push("/intelligentbigdata/home");
  };

  /**
   * 存数据
   */
  storageData = (name) => {
    const { dispatch } = this.props;
    if (this.state.type === "school") {
      dispatch(intelligentbigdataActions.setSchoolName(name));
    } else if (this.state.type === "major") {
      dispatch(intelligentbigdataActions.setMajorName(name));
    }
  };
  /**
   * 重置数据
   */
  resetData = () => {
    const { dispatch } = this.props;
    if (this.state.type === "school") {
      dispatch(intelligentbigdataActions.setSchoolName(""));
    } else if (this.state.type === "major") {
      dispatch(intelligentbigdataActions.setMajorName(""));
    }
  };
  /**
   * 重置页码
   */
  resetPageNum = () => {
    const { dispatch } = this.props;
    dispatch(intelligentbigdataActions.setPageNum(1));
  };
  /**
   * 点击搜索跳转到智能大数据查询列表页面
   */
  handleSearch = () => {
    this.storageData(this.state.name);
    this.resetPageNum();
    this.props.history.push("/intelligentbigdata/home");
  };
  /**
   * input输入框变化的时候
   */
  handleChang = (e) => {
    this.setState({
      name: e.target.value,
    });
    if (e.target.value.length > 0) {
      this.setState({
        clickName: "搜索",
      });
      if (this.state.type === "school") {
        get("/public/v1/intelligent/search/school/" + e.target.value).then((res) => {
          this.setState({
            keys: res.data,
          });
        });
      } else if (this.state.type === "major") {
        get("/public/v1/intelligent/search/major/" + e.target.value).then((res) => {
          this.setState({
            keys: res.data,
          });
        });
      }
    } else {
      this.setState({
        clickName: "取消",
        keys: [],
      });
    }
  };
  /**
   * 移除搜索框内的条件
   */
  handleRemoveName = () => {
    this.resetData();
    this.setState({
      clickName: "取消",
      name: "",
      keys: [],
    });
  };
}
const mapStateToProps = (state) => {
  return {
    schoolFilter: state.intelligentbigdata.schoolFilterData,
  };
};

export default connect(mapStateToProps)(
  withRouter(IntelligentBigDataKeySearch)
);



// WEBPACK FOOTER //
// ./src/containers/IntelligentBigData/IntelligentBigDataKeySearch/index.js